import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    name: { label: i18n.t('app.name'), value: '' },
    url: { label: i18n.t('app.url'), value: '' },
    notificationType: { label: i18n.t('historical.evento'), value: '' },
    activo: { label: i18n.t('app.active'), value: '' },
  } 
}
const getColumns = function getColumns () {
  return [
    { field: 'IdWebHookSubscriber', width: '100px', title: i18n.t('app.id'), columnMenu: 'myTemplate', locked: false, groupable: false, hidden: true },
    { field: 'Name', width: '320px', title: i18n.t('app.name'), columnMenu: 'myTemplate', locked: false, groupable: false },
    { field: 'WebHookURL', width: '830px', title: i18n.t('app.url'), columnMenu: 'myTemplate', locked: false, groupable: false },
    { field: 'NotificationType', width: '210px', title: i18n.t('app.type'), columnMenu: 'myTemplate', locked: false },
    {
      field: 'Active',
      width: '100px',
      title: i18n.t('app.active'),
      columnMenu: 'myTemplate',
      locked: false,
      cell: 'checkboxTemplate',
      extraparams: { groupHeaderTemplate: ({ value, aggregates }) => value ? i18n.t('app.active') : i18n.t('app.not_active') }
    }
  ] 
}
const mystore = parent({ selectable: true, navigate: true, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
